// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3rZDF","buttons":"RemoveExpirationActionButtons_buttons__RSxDC"};